module.exports = __webpack_public_path__ + "static/media/snap.f8ac4af0.svg";